import { RootComponent } from './Root.component';
import { enhance } from './Root.enhancers';

export const Root = enhance(RootComponent);
